export const CONTACT_PROBLEM_LIST_REQUEST =
  'contact/CONTACT_PROBLEM_LIST_REQUEST';

export const CONTACT_FORM_CHANGE_TYPE = 'contact/CONTACT_FORM_CHANGE_TYPE';
export const CONTACT_FORM_SAVE_FIELD = 'contact/CONTACT_FORM_SAVE_FIELD';

export const POST_CONTACT = 'contact/POST_CONTACT';
export const POST_CONTACT_SUCCESS = 'contact/POST_CONTACT_SUCCESS';
export const POST_CONTACT_FAIL = 'contact/POST_CONTACT_FAIL';

export const RESET_CONTACT_FORM_FIELD = 'contact/RESET_CONTACT_FORM_FIELD';
